import React, { Component } from "react";
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

class Login extends Component {
    render() {
        var host = window.location.hostname;
        let loginHref;
        // if (host === 'localhost') {
        //     loginHref = '/api/sso/login/localhost';

        // } else {
        //     loginHref = '/api/sso/login';
        // }
        loginHref = '/api/b2c/signin';
        //loginHref = '/api/sso/login/localhost';
        return (
            <div className="login-content">
                <Card className="login-card">
                    <CardMedia
                        className="login-image"
                        image="/images/WorldWideWelcome.svg"
                        title="ComplianceWorks"
                    />
                    <CardContent>
                        Please Login
                        <Typography component="p">
                            This is a secure site. Please log in with your Bechtel credentials to continue.
                        </Typography>
                        <a href={loginHref} className=""> 
                            <Button variant="outlined" color="primary" className="attending-button-admin"> Login </Button>            
                        </a>
                    </CardContent>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { login } = state;
    return { login };
};

export default connect(mapStateToProps)(Login);